import type { Dayjs } from 'dayjs';
import type { DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import type { TextFieldProps } from '@mui/material/TextField';

import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { formatStr } from 'src/utils/format-time';

// ----------------------------------------------------------------------

type RestrictedDatePickerProps = DatePickerProps<Dayjs> & {
  dueDate?: Dayjs;
  earliestStart?: Dayjs;
  latestStart?: Dayjs;
  slotProps?: {
    textField?: TextFieldProps;
  };
};

export function RestrictedDatePicker({
  dueDate,
  earliestStart,
  latestStart,
  slotProps,
  ...other
}: RestrictedDatePickerProps) {
  const today = dayjs();
  
  const shouldDisableDate = (date: Dayjs) => {
    if (earliestStart && date.isBefore(earliestStart, 'day')) {
      return true;
    }
    if (latestStart && date.isAfter(latestStart, 'day')) {
      return true;
    }
    // Disable dates after due date
    if (dueDate && date.isAfter(dueDate, 'day')) {
      return true;
    }
    // Disable dates before today
    if (date.isBefore(today, 'day')) {
      return true;
    }
    return false;
  };

  return (
    <DatePicker
      {...other}
      format={formatStr.split.date}
      shouldDisableDate={shouldDisableDate}
      slotProps={{
        textField: {
          fullWidth: true,
          ...slotProps?.textField,
        },
        ...slotProps,
      }}
    />
  );
} 